<template>
    <LayoutCookieConsentWrapper
        class="video-player"
        type="video"
        disabledMessage="Accept cookies to watch this video."
        :disabledPoster="poster"
        @cookies-accepted="acceptCookies"
    >
        <span class="block aspect-video bg-black relative">
            <span v-if="activated">
                <video
                    @contextmenu.prevent
                    ref="video"
                    class="video-player video-js vjs-16-9 vjs-skin vjs-show-big-play-button-on-pause aspect-video w-full"
                    :poster="poster"
                    preload="none"
                    controls
                    playsinline
                >
                    <source
                        v-for="(source, index) in sources"
                        :key="'video-player-source-' + index"
                        :src="source.src"
                        :type="source.type"
                    >
                </video>
            </span>
            <span v-if="!activated" class="h-full text-white flex items-center justify-center cursor-pointer relative" @click="activate">
                <img class="block w-full h-full object-cover absolute" :src="poster" alt="" />
                <button aria-label="Play Video" class="absolute z-10 rounded-lg bg-red-600 bg-opacity-80 px-8 py-3 text-white hover:bg-opacity-100">
                    <IconPlay></IconPlay>
                </button>
            </span>
        </span>
    </LayoutCookieConsentWrapper>
</template>

<script>
export default {
    name: 'VideoPlayer',
    data () {
        return {
            player: null,
            hasBeenUnmounted: false,
            activated: false,
        };
    },
    props: {
        sources: {
            required: true,
            type: Array,
        },
        poster: {
            required: false,
            type: String,
            default: null,
        }
    },
    methods: {
        async activate () {
            this.$el.dispatchEvent(new Event('play'));
            this.activated = true;
            this.$nextTick(async () => {
                const videoElement = this.$refs.video;
                const videojs = usePluginVideo();
                await videojs.init();
                if (this.hasBeenUnmounted) return; // Sometimes component is unmounted before videoJs.init completes but reference to the videoElement still exists
                this.player = this.$videojs(videoElement, {
                    preload: 'auto',
                    autoplay: true,
                    controls: true,
                    poster: this.poster,
                    fluid: true,
                    playbackRates: [0.5, 1, 1.5, 2],
                    userActions: {
                        hotkeys: true,
                    },
                });
            });
        },
        async acceptCookies () {
            await this.$nextTick();
            await this.activate();
        }
    },
    watch: {
        poster () {
            if (this.player) {
                this.player.poster(this.poster);
            }
        }
    },
    beforeUnmount () {
        this.hasBeenUnmounted = true;
        if (this.player) {
            this.player.dispose();
        }
    }
};
</script>
